import {GET_ERRORS, HIDE_MESSAGE} from '../actions/types';

const initialState = {
  msg: '',
  status: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_ERRORS:
      return {
        msg: action.payload.msg,
        status: action.payload.status,
      };
    case HIDE_MESSAGE:
      return {
        ...state,
        msg: '',
      };
    default:
      return state;
  }
}
